import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { DatePicker } from "@/components/ui/date-picker";

const INVESTIGATION_OPTIONS = ["HbA1c", "Fasting Sugar", "PPBS", "Lipid Profile", "Creatinine", "eGFR", "Urine Albumin", "CBC", "LFT", "Thyroid"];

// "Recommended Investigations" pill-picker + custom investigation input, plus
// the "Follow-up" date/notes fields, for the Consultation page.
export function ConsultationInvestigationsSection({ investigations, toggleInvestigation, customInvestigation, setCustomInvestigation, followupDate, setFollowupDate, followupNotes, setFollowupNotes }) {
  return (
    <div className="card-surface card-surface-hover rounded-xl border border-slate-200 bg-white shadow-sm p-6">
      <h2 className="font-semibold text-slate-900">Recommended Investigations</h2>
      <div className="mt-3 flex flex-wrap gap-2">
        {INVESTIGATION_OPTIONS.map((opt) => (
          <button
            key={opt}
            data-testid={`investigation-${opt.replace(/\s/g, "-")}`}
            onClick={() => toggleInvestigation(opt)}
            className={`rounded-full px-3 py-1 text-xs font-medium border ${investigations.includes(opt) ? "bg-teal-700 text-white border-teal-700" : "border-slate-200 text-slate-600 hover:bg-slate-50"}`}
          >
            {opt}
          </button>
        ))}
      </div>
      <div className="mt-3">
        <Label>Other Investigation (custom, comma-separated)</Label>
        <Input
          data-testid="custom-investigation-input"
          placeholder="e.g. Vitamin D, Chest X-Ray"
          value={customInvestigation}
          onChange={(e) => setCustomInvestigation(e.target.value)}
        />
      </div>
      <h2 className="mt-6 font-semibold text-slate-900">Follow-up</h2>
      <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div><Label>Next Visit Date</Label><DatePicker testId="followup-date" value={followupDate} onChange={setFollowupDate} fromYear={new Date().getFullYear()} /></div>
        <div><Label>Additional Notes</Label><Input data-testid="followup-notes" value={followupNotes} onChange={(e) => setFollowupNotes(e.target.value)} /></div>
      </div>
    </div>
  );
}
